module.exports = "../dist/img/img_1-42.71dc.jpg";